'use strict';

import TS from "@zerolight/zlthunder-time-utils";
import numeral from "numeral";
import {getFieldName, getFieldTitle, formatMinutes as _formatMinutes} from '../../shared/utils';

function safeNumber(n) {
	n = Number(n);
	return !isNaN(n) ? n : null;
}

function safeMinutes(n) {
	n = safeNumber(n);
	return n !== null ? Math.ceil(n / TS.MINUTE) : null;
}

function formatNumber(n) {
	n = safeNumber(n);
	return n ? numeral(n).format('0,0') : null;
}

function formatMinutes(n) {
	n = safeMinutes(n);
	return n ? numeral(n).format('0,0') : null;
}

function formatSessionLength(n) {
	n = safeNumber(n);
	return n ? _formatMinutes(n / 1000) : null;
}

function getValue(summary, getter) {
	if (!summary) {
		return null;
	}
	if (!(getter instanceof Function)) {
		let key = getter;
		getter = (s) => (s && s.hasOwnProperty(key) ? s[key] : null);
	}
	return getter(summary);
}

function formatValue(summary, getter, formatter) {
	if (!formatter) {
		formatter = (v => (v !== null ? String(v) : null));
	}
	return formatter(getValue(summary, getter));
}

function extendFilter(filter, extension) {
	for (let [key, value] of Object.entries(extension)) {
		let current = new Set(filter[key] || []);
		if (!Array.isArray(value)) {
			value = [value];
		}
		for (let v of value) {
			current.add(v);
		}
		filter[key] = Array.from(current);
	}
	return filter;
}

function add(a, b) {
	return a + b;
}

function safeNumberOp(a, b, op) {
	a = Number(a);
	a = !isNaN(a) ? a : 0;
	b = Number(b);
	b = !isNaN(b) ? b : 0;
	return op(a, b);
}

function isSummaryStale(s) {
	return !s || !s.hasOwnProperty('stale') || Boolean(s.stale);
}

function addSummaries(s1, s2) {
	if (isSummaryStale(s1) || isSummaryStale(s2)) {
		return {stale: true, count: 0};
	}

	let r = Object.assign({stale: false, count: 0}, s1);
	if (!s2) {
		return r;
	}
	let count = safeNumberOp(s1.count, s2.count, add);
	if (!count) {
		return {stale: false, count: 0};
	}
	r.stale = false;
	r.count = count;
	r.total = safeNumberOp(s1.total, s2.total, add);
	r.max = safeNumberOp(s1.max, s2.max, Math.max);
	r.min = safeNumberOp(s1.min, s2.min, Math.min);
	return r;
}




export {
	getFieldName, getFieldTitle,
	safeNumber, safeMinutes, formatNumber,
	formatMinutes, formatSessionLength,
	getValue, formatValue, extendFilter,
	addSummaries, safeNumberOp
};